import { FaCheckCircle } from "../Icon/fa/FaCheckCircle";

export default function CheckContent({ data, icon, ...props }) {
  return (
    <div className="mt-2 first:mt-0" {...props}>
      <div className="flex items-start ">
        <span>
          {icon || (
            <FaCheckCircle size={16} className="mr-2 mt-1 text-gleads-basic" />
          )}
        </span>
        <span dangerouslySetInnerHTML={{ __html: data }}></span>
      </div>
    </div>
  );
}
